export const claimReasonInfoStrings = {
	stfi: 'STFI stands for Storm, Tempest, Flood, Inundation, Hurricane, Cyclone, Typhoon and Tornado.',
	flexa: 'FLEXA stands for Fire, Lightning, EXplosion, Aircraft impact',
	earthquake:
		'Damage or loss of the Insured’s Property caused by Earthquake Fire or Earthquake Shock.',
	rsmd: 'RSMD stands for Riot, Strike, Malicious damage.',
	terrorism:
		'Loss, damage, cost or expense of whatsoever nature directly or indirectly caused by, resulting from or in connection with any act of terrorism.',
}
